.noselect {
  -webkit-touch-callout: none;
  user-select: none;
}

.rv-select {
  position: relative;
  display: flex;
  font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial,
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  color: rgb(0 0 0 / 87%);
  border: 0;
  margin: 0;
  cursor: pointer;
}

.rv-select-text {
  box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%),
    0 3px 14px 2px rgb(0 0 0 / 12%);
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 8px;

  * {
    color: rgb(0 0 0 / 87%);
    background-color: rgb(0 0 0 / 0%);
    min-height: 16px;
    min-width: calc(100% - 32px);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    padding: 6px 16px;
    white-space: nowrap;
  }

  *:hover,
  *:focus {
    background: rgb(0 0 0 / 4%);
  }

  .rv-select-text-selected {
    background: rgb(0 0 0 / 8%);
  }

  position: absolute;
  visibility: hidden;
  z-index: 1;
  margin: 2px;
  border-radius: 4px;
  color: #fff;
  overflow-wrap: break-word;
  text-align: left;
  font-size: 11px;
  background-color: white;
}

.rv-right {
  top: 24px;
  left: -2px;
}

.rv-left {
  top: 24px;
  right: -2px;
}

.rv-center {
  top: 24px;
  left: -60px;
}

.rv-select-text-open {
  visibility: visible;
  flex-shrink: 0;
}
